export default __webpack_public_path__ + "static/media/body-2.a37c32e3.png";